//main
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function calculateExtraDiscount(originalPrice, desiredDiscountedPrice, initialDiscountPercentage) {
  const totalDiscountNeeded = ((originalPrice - desiredDiscountedPrice) / originalPrice) * 100;
  const extraDiscountNeeded = totalDiscountNeeded - initialDiscountPercentage;
  return parseFloat(extraDiscountNeeded) > 0 ? parseFloat(extraDiscountNeeded).toFixed(4): 0;
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// Custom MottAndBow Created function formatMoneyAmmount
// This function is used to format the price amount in the format of the currency
// 
Shopify.formatMoneyAmmount = function(number) {
  
  const formatReference = document.querySelector("#price-format-guide");

  if (!formatReference) {
    throw new Error("Missing price format guide element (#price-format-guide).");
  }

  const formatExample = formatReference.textContent.trim();
  let usesCommas = formatExample.indexOf(",") < formatExample.indexOf("."); // Check if commas come before periods

  // Stricter input validation with type check and NaN check
  if (typeof number !== "number" || isNaN(number)) {
    throw new TypeError("Input must be a valid number.");
  }

  // Formatting logic
  let formattedAmount = number;

  // Ensure 'number' is parsed as a float to prevent formatting issues
  let parsedNumber = parseFloat(number);
  //debugger;
  console.log(Math.floor(number).toString());
  console.log(number.toString());
  
  if (  Math.floor(number).toString() != number.toString() ) {
   
    formattedAmount = parsedNumber.toFixed(2);
  }
  
  if (usesCommas) {
    // Commas for thousands, periods for decimals

    // Use Intl.NumberFormat to format numbers with commas for thousands and points for decimals
    const formatter = new Intl.NumberFormat('en-US');
    formattedAmount = formatter.format(formattedAmount);
    if (formattedAmount.toString().split('.').length > 1) {
      if (formattedAmount.toString().split('.')[1].length == 1) {
        formattedAmount = formattedAmount + '0';
      }
    }
  } else {



    // Use Intl.NumberFormat to format numbers with periods for thousands and commas for decimals
    const formatter = new Intl.NumberFormat('de-DE'); // 'de-DE' uses the format you're looking for

    
    formattedAmount = formatter.format(formattedAmount);

    if (formattedAmount.toString().split(',').length > 1) {
      if (formattedAmount.toString().split(',')[1].length == 1) {
        formattedAmount = formattedAmount + '0';
      }
    }
    
  }
  return formattedAmount; 
}
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
    this.querySelectorAll(".disclosure__list li a").forEach((item) =>
      item.addEventListener("click", this.onClickLocalization.bind(this))
    );
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      if (element.nextElementSibling)
        element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      // this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      //   details.removeAttribute('open');
      //   details.classList.remove('menu-opening');
      // });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onClickLocalization(event) {
    event.preventDefault();
    const form = event.currentTarget.closest("form");
    console.log(form);
    if (!form) return;
    form.querySelector(
      'input[name="language_code"], input[name="country_code"]'
    ).value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}



customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class MobileNavbar extends MenuDrawer {
  constructor() {
    super();

    this.mainSummary = this.querySelector("summary.header__icon--menu");
    this.mainSummary.addEventListener("click", this.onOverlayClick.bind(this));
    this.closeBtn = this.querySelector(".close_nav_btn");
    this.closeBtn.addEventListener("click", this.onCloseClick.bind(this));

    this.switchBtns = this.querySelectorAll(
      ".navigation_toggle-container .switch--btn"
    );
    this.switchInit();

    this.darkOverlay = this.querySelector(".dark-overlay");
    this.darkOverlay.addEventListener("click", this.onOverlayClick.bind(this));
  }

  switchInit() {
    this.switchBtns.forEach((switchBtn) => {
      switchBtn.addEventListener("click", this.onSwitchClick.bind(this));
    });

    const activeSwitchBtn = this.querySelectorAll(
      ".navigation_toggle-container .switch--btn.switch-active"
    );
    const activeSwitchDrawers = this.querySelectorAll(
      ".switch-menu-drawer.switch-active"
    );

    if (
      this.switchBtns &&
      this.switchBtns.length > 0 &&
      (!activeSwitchBtn || activeSwitchBtn.length <= 0)
    ) {
      const evt = new Event("click");
      this.switchBtns[0].dispatchEvent(evt);
    }
    // more than 1 switch buttons are active due to overlapping childmenu elements
    else if (activeSwitchBtn.length > 1) {
      const prevMenuClicked = localStorage.getItem("mobmenu");
      // turn off all the active buttons if it does not match the previous clicked attribute
      activeSwitchBtn.forEach((btn, index) => {
        if (prevMenuClicked) {
          btn.id !== `toggle-${prevMenuClicked}`
            ? btn.classList.remove("switch-active")
            : "";
        } else {
          index === 0 ? "" : btn.classList.remove("switch-active");
        }
      });
      // do the same for drawers
      activeSwitchDrawers.forEach((drawer, index) => {
        if (prevMenuClicked) {
          drawer.id !== `drawer-${prevMenuClicked}`
            ? drawer.classList.remove("switch-active")
            : "";
        } else {
          index === 0 ? "" : drawer.classList.remove("switch-active");
        }
      });
    }
  }

  onSwitchClick(event) {
    event.preventDefault();
    const currentBtn = event.target;
    const currentId = currentBtn.id;
    // save the clicked menu as "previous element clicked"
    // This value will be used when there are move than 1 active switch buttons due to overlapping child menus
    localStorage.setItem("mobmenu", currentId.split("toggle-")[1]);
    const menuToToggle = this.querySelector(`ul[data-link-id="${currentId}"]`);

    const activeBtn = currentBtn.parentElement.querySelector(".switch-active");
    const activeMenu = currentBtn
      .closest(".menu-drawer__navigation")
      .querySelector("ul.switch-active");

    if (activeBtn && activeBtn != currentBtn) {
      activeBtn.classList.remove("switch-active");
      currentBtn.classList.add("switch-active");
    } else {
      currentBtn.classList.add("switch-active");
    }

    if (activeMenu && activeMenu != menuToToggle) {
      activeMenu.classList.remove("switch-active");
      menuToToggle.classList.add("switch-active");
    } else {
      menuToToggle.classList.add("switch-active");
    }
  }

  onCloseClick(event) {
    const mainSummary = this.mainSummary;
    const mainDetail = this.mainDetailsToggle;
    this.darkOverlay.classList.remove("active");

    this.closeMenuDrawer(mainSummary);
  }

  onOverlayClick(event) {
    const mainSummary = this.mainSummary;
    const mainDetail = this.mainDetailsToggle;
    const isOpen = mainDetail.hasAttribute("open");
    this.darkOverlay.classList.toggle("active");

    if (isOpen) event.preventDefault();
    isOpen
      ? this.closeMenuDrawer(mainSummary)
      : this.openMenuDrawer(mainSummary);
  }
}

customElements.define("mobile-navbar", MobileNavbar);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector(".template-popup")?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    // property for sliding action
    // this.moved = false;

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    // desktop sliding action
    // this.slider.addEventListener("mousedown", this.downListener.bind(this));
    // this.slider.addEventListener("mousemove", this.moveListener.bind(this));

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.relatedList = window.theme.related_prod_handles;
    this.relatedInventoryStatus = [];
    // Preorder
    this.preorderMessage = document.querySelector(
      ".product-form .preorder-text"
    );
    // Pre-Order product data
    this.preOrderProduct = null;
    this.preOrderProductData = null;
    this.preOrderHandle = window.theme?.pre_order_handle || null;
    this.enablePreOrder = window.theme?.enable_pre_order || false;
    this.enablePreOrderNonUSA = window.theme?.enable_pre_order_non_usa || false;
    this.countryCode = window.theme?.country_code || null;
    // Flag to indicate if pre-order is available for current variant
    this.hasPreOrderAvailable = false;

    this.init();
    this.multiBundle = document.querySelector('multi-bundle');
  }

  init() {
    this.relatedList.forEach((rel_prod) => {
      fetch(`${Shopify.routes.root}products/${rel_prod}?view=inventory_status`)
        .then((response) => response.json())
        .then((data) => {
          this.relatedInventoryStatus.push(data);

        });
    });
    
    // Load Pre-Order product if handle exists
    if (this.preOrderHandle) {
      this.loadPreOrderProduct();
    }
  }

  async loadPreOrderProduct() {
    if (!this.preOrderHandle) return;
    
    try {
      const response = await fetch(`${Shopify.routes.root}products/${this.preOrderHandle}?view=inventory_status`);
      if (response.ok) {
        const data = await response.json();
        this.preOrderProductData = data;
        
        // Also fetch full product data for variants
        const fullProductResponse = await fetch(`${Shopify.routes.root}products/${this.preOrderHandle}.js`);
        if (fullProductResponse.ok) {
          this.preOrderProduct = await fullProductResponse.json();
          // Update Pre-Order button after loading
          this.togglePreOrderButton();
          // Update Add to Cart button after pre-order check
          const addButton = document.querySelector(".product-form__submit");
          if (addButton) {
            this.updateAddToCartButtonContent(addButton);
          }
        }
      }
    } catch (error) {
      console.log('Pre-Order product not found or error loading:', error);
      this.preOrderProduct = null;
      this.preOrderProductData = null;
    }
  }

  async updatePreOrderForNewProduct(productHandle, productTags) {
    // Update Pre-Order handle
    const newPreOrderHandle = `${productHandle}-pre`;
    this.preOrderHandle = newPreOrderHandle;
    window.theme.pre_order_handle = newPreOrderHandle;
    
    // Check for enable_pre-order tag
    let hasPreOrderTag = false;
    let preOrderDate = null;
    
    for (const tag of productTags) {
      if (tag.includes('enable_pre-order')) {
        hasPreOrderTag = true;
        // Extract date if exists (format: enable_pre-order_YYYY-MM-DD)
        if (tag.includes('enable_pre-order_')) {
          preOrderDate = tag.split('enable_pre-order_')[1];
        }
        break;
      }
    }
    
    // Update global settings
    this.enablePreOrder = hasPreOrderTag;
    window.theme.enable_pre_order = hasPreOrderTag;
    window.theme.pre_order_date = preOrderDate;
    
    // Update country settings from window.theme (these shouldn't change but ensure they're synced)
    this.enablePreOrderNonUSA = window.theme?.enable_pre_order_non_usa || false;
    this.countryCode = window.theme?.country_code || null;
    
    // Reset Pre-Order product data
    this.preOrderProduct = null;
    this.preOrderProductData = null;
    
    // Load new Pre-Order product
    await this.loadPreOrderProduct();
    
    // Update Pre-Order button after loading (with delay to ensure variant is updated)
    setTimeout(() => {
      this.togglePreOrderButton();
      // Update Add to Cart button after pre-order check
      const addButton = document.querySelector(".product-form__submit");
      if (addButton) {
        this.updateAddToCartButtonContent(addButton);
      }
    }, 300);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();

    if (!this.currentVariant) {
      // this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.availableSize();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      // Load Pre-Order product if not already loaded and variant is selected
      if (this.preOrderHandle && !this.preOrderProduct) {
        this.loadPreOrderProduct().then(() => {
          this.togglePreOrderButton();
        });
      } else {
        this.togglePreOrderButton();
      }
    }
    this.toggleShowBtn();
    console.log("toggleShowBtn 1");
  }

  disableSubmitBtn() {
    
    if (predictProduct.handle == "digital-gift-card") return;
    const addButton = document.querySelector(".product-form__submit");
    const notifyButton = document.querySelector(".klaviyo-bis-trigger");
    const radioGroups = document.querySelectorAll(".product-form__input:not(.jean-pack)");
    const productForm = document.querySelector(".product-form");
    var showFlag = 0;
    console.log(radioGroups);
    radioGroups.forEach((optionGroup) => {
      const radioInputs = optionGroup.querySelectorAll("input[type='radio']:checked:not(.pack)");

      if (
        optionGroup.dataset.optionName !== "Color" && optionGroup.dataset.optionName !== "Couleur" &&
        radioInputs.length > 0
      ) {
        showFlag++;
      }
    });
    // if exist <fieldset class="js product-form__input" data-option-name="Waist" data-option-index="option2">
    
    let inseamSelector = document.querySelector(".product-form__input[data-option-name='Inseam']");
    let waistSelector = document.querySelector(".product-form__input[data-option-name='Waist']");
   
    if (inseamSelector || waistSelector) {
      let selectedInseam = inseamSelector.querySelector("input[type='radio']:checked");
      let selectedWaist = waistSelector.querySelector("input[type='radio']:checked");
      
      if (showFlag == radioGroups.length - 1) {
        
        addButton.classList.add("disable-select-size");
        console.log("add disable b 1");
        this.updateAddToCartButtonSoldOut(addButton);
        addButton.disabled = true;
        if (productForm.classList.contains("waitlist-template")) {
          addButton.style.display = "none";
          // Handle Notify button visibility
          this.toggleNotifyButton();

          if (selectedInseam && selectedWaist) {
            if(selectedInseam.disabled || selectedWaist.disabled) {
              // If size is disabled, hide notify button
              notifyButton.classList.add("hide");
              notifyButton.classList.remove("enabled");
              this.updateAddToCartButtonSoldOut(addButton);
              addButton.disabled = true;
              addButton.style.display = "block";
            }
          }


        } else {
          addButton.style.display = "block";
          // Handle Notify button visibility
          this.toggleNotifyButton();
        }
      }
    } else if (!document.querySelector("product-pack")) {
      if (showFlag == radioGroups.length - 1) {

        addButton.classList.add("disable-select-size");
        console.log("add disable b 1");
        this.updateAddToCartButtonSoldOut(addButton);
        addButton.disabled = true;
        if (productForm.classList.contains("waitlist-template")) {
          addButton.style.display = "none";
          // Handle Notify button visibility
          this.toggleNotifyButton();
          
        } else {
          addButton.style.display = "block";
          // Handle Notify button visibility
          this.toggleNotifyButton();
        }
      }
    } else {
      console.log("showFlag" + showFlag);
      console.log("(radioGroups.length - 2)");
      console.log(radioGroups.length - 2);
      if (showFlag == radioGroups.length - 2) {

        addButton.classList.add("disable-select-size");
        console.log("add disable b 1");
        this.updateAddToCartButtonSoldOut(addButton);
        addButton.disabled = true;
        if (productForm.classList.contains("waitlist-template")) {
          addButton.style.display = "none";
          // Handle Notify button visibility
          this.toggleNotifyButton();

          // get the selected size 
          let selectedSize = document.querySelector(".product-form__input[data-option-name='Size'] input[type='radio']:checked");
          if (selectedSize) {
            if(selectedSize.disabled) {
              // If size is disabled, hide notify button
              notifyButton.classList.add("hide");
              notifyButton.classList.remove("enabled");
              this.updateAddToCartButtonSoldOut(addButton);
              addButton.disabled = true;
              addButton.style.display = "block";
            }
          }
          
        } else {
          addButton.style.display = "block";
          // Handle Notify button visibility
          this.toggleNotifyButton();
        }
      }
    }



  }
  enableSubmitBtn() {

    const addButton = document.querySelector(".product-form__submit");
    const preOrderButton = document.querySelector(".product-form__preorder-submit");
    const notifyButton = document.querySelector(".klaviyo-bis-trigger");
    const productForm = document.querySelector(".product-form");
    addButton.classList.remove("disable-select-size");
    console.log("remove disable b 1");
    addButton.style.display = "block";
    if (productForm.classList.contains("preorder-template")) {
      var preOrderQuantity = 0;
      for (var i = 0; i < this.relatedInventoryStatus.length; i++) {
        const product = this.relatedInventoryStatus[i];
        var selectedVariant = product.inventory.find((variant) => {
          if (variant.id == this.currentVariant.id) {
            return variant;
          }
        });
        if (selectedVariant) {
          preOrderQuantity = selectedVariant.quantity;
        }
      }

      if (this.preorderMessage) {
        this.preorderMessage.style.display = "none";
      }

      if (preOrderQuantity <= 0) {
        // Update button to show Pre-Order but keep structure
        const textElement = addButton.querySelector(".addtocart-button-text");
        const statusElement = addButton.querySelector(".addtocart-button-status");
        if (textElement) {
          textElement.textContent = "Pre-Order";
        }
        if (statusElement) {
          statusElement.textContent = '';
        }
        
        var preOrderInput = document.createElement("input");
        preOrderInput.setAttribute("id", "preorder-property");
        preOrderInput.setAttribute("type", "hidden");
        preOrderInput.setAttribute("name", "properties[Pre-Order]");
        if (this.preorderMessage) {
          this.preorderMessage.style.display = "block";
          preOrderInput.setAttribute("value", this.preorderMessage.innerText);
        }

        productForm.querySelector("form").prepend(preOrderInput);
      } else {
        // Update Add to Cart button with new format
        this.updateAddToCartButtonContent(addButton);
        const preOrderInput = productForm.querySelector("#preorder-property");
        if (preOrderInput) {
          preOrderInput.remove();
        }
      }
    } else {
      // Update Add to Cart button with new format
      this.updateAddToCartButtonContent(addButton);
    }
    addButton.disabled = false;
    
    // Handle Pre-Order button visibility
    this.togglePreOrderButton();
    
    // Update Add to Cart button based on pre-order availability
    this.updateAddToCartButtonContent(addButton);
    
    // Handle Notify button visibility
    this.toggleNotifyButton();
  }

  updateAddToCartButtonContent(button) {
    if (!button) return;
    
    const textElement = button.querySelector(".addtocart-button-text");
    const priceElement = button.querySelector(".addtocart-button-price");
    const comparePriceElement = button.querySelector(".addtocart-button-compare-price");
    const statusElement = button.querySelector(".addtocart-button-status");
    
    // If button doesn't have the new structure, skip update (fallback to old format)
    if (!textElement || !priceElement) {
      return;
    }
    
    // If currentVariant is not available yet, try to get it from the form
    if (!this.currentVariant) {
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        const variantId = parseInt(variantInput.value);
        const variantData = this.getVariantData();
        this.currentVariant = variantData.find(v => v.id === variantId);
      }
    }
    
    // Update text
    if (textElement) {
      if (this.currentVariant && this.currentVariant.available) {
        textElement.textContent = window.theme.add_to_cart ? window.theme.add_to_cart : "Add to Cart";
      } else {
        textElement.textContent = "Sold Out";
      }
    }
    
    // Update price - only show if pre-order is available
    const priceWrapper = button.querySelector(".addtocart-button-price-wrapper");
    if (this.hasPreOrderAvailable && priceElement && this.currentVariant) {
      const price = this.currentVariant.price / 100; // Convert from cents to dollars
      const compareAtPrice = this.currentVariant.compare_at_price ? this.currentVariant.compare_at_price / 100 : null;
      const currencySymbol = window.theme?.cart_currency_symbol || '$';
      const shopCurrency = window.theme?.shop_currency || '';
      
      // Show price wrapper
      if (priceWrapper) {
        priceWrapper.style.removeProperty('display');
        priceWrapper.style.display = 'inline';
      }
      
      // Show compare at price if exists (tachado)
      if (comparePriceElement && compareAtPrice && compareAtPrice > price) {
        comparePriceElement.innerHTML = `<s>${currencySymbol}${Shopify.formatMoneyAmmount(compareAtPrice)} ${shopCurrency}</s> `;
        comparePriceElement.style.display = 'inline';
      } else if (comparePriceElement) {
        comparePriceElement.textContent = '';
        comparePriceElement.style.display = 'none';
      }
      
      // Show current price
      priceElement.textContent = `${currencySymbol}${Shopify.formatMoneyAmmount(price)} ${shopCurrency}`;
    } else {
      // Hide price wrapper and clear price if no pre-order available
      if (priceWrapper) {
        priceWrapper.style.setProperty('display', 'none', 'important');
      }
      if (priceElement) {
        priceElement.textContent = '';
      }
      if (comparePriceElement) {
        comparePriceElement.textContent = '';
        comparePriceElement.style.display = 'none';
      }
    }
    
    // Update status - only show if pre-order is available
    if (statusElement) {
      if (this.hasPreOrderAvailable && this.currentVariant && this.currentVariant.available) {
        statusElement.textContent = "In Stock. Ready to Ship.";
      } else {
        statusElement.textContent = '';
      }
    }
  }

  updateAddToCartButtonSoldOut(button) {
    if (!button) return;
    
    const textElement = button.querySelector(".addtocart-button-text");
    const priceElement = button.querySelector(".addtocart-button-price");
    const comparePriceElement = button.querySelector(".addtocart-button-compare-price");
    const statusElement = button.querySelector(".addtocart-button-status");
    
    // If button doesn't have the new structure, use old format
    if (!textElement) {
      button.innerHTML = "Sold Out";
      return;
    }
    
    // Update text
    if (textElement) {
      textElement.textContent = "Sold Out";
    }
    
    // Hide price and status for sold out
    if (priceElement) {
      priceElement.textContent = '';
    }
    if (comparePriceElement) {
      comparePriceElement.textContent = '';
      comparePriceElement.style.display = 'none';
    }
    if (statusElement) {
      statusElement.textContent = '';
    }
  }

  toggleNotifyButton() {
    const notifyButton = document.querySelector(".klaviyo-bis-trigger");
    if (!notifyButton) return;

    const productForm = document.querySelector(".product-form");
    const preOrderButton = document.querySelector(".product-form__preorder-submit");
    
    // Hide notify button by default
    notifyButton.classList.add("hide");
    notifyButton.classList.remove("enabled");
    
    // If pre-order button is visible, always hide notify button
    if (preOrderButton && !preOrderButton.classList.contains("hidden")) {
      return;
    }
    
    // Show notify button only if:
    // 1. A variant is selected (currentVariant exists)
    // 2. Variant is not available (sold out)
    // 3. Product form has waitlist-template class
    // 4. Pre-order button is NOT visible
    if (this.currentVariant && !this.currentVariant.available && productForm && productForm.classList.contains("waitlist-template")) {
      notifyButton.classList.remove("hide");
      notifyButton.classList.add("enabled");
    }
  }

  togglePreOrderButton() {
    const preOrderButton = document.querySelector(".product-form__preorder-submit");
    if (!preOrderButton) {
      // If no pre-order button exists, set flag to false
      this.hasPreOrderAvailable = false;
      // Still check notify button since pre-order is not available
      this.toggleNotifyButton();
      return;
    }

    const productForm = document.querySelector(".product-form");
    
    // Hide Pre-Order button by default
    preOrderButton.classList.add("hidden");
    // Set flag to false by default
    this.hasPreOrderAvailable = false;
    
    // Early returns for missing required data - but check notify button first
    if (!this.currentVariant || !this.preOrderProduct) {
      // If no pre-order product but variant exists and is sold out, show notify button
      this.toggleNotifyButton();
      return;
    }

    // Check if Size is actually selected - verify directly from DOM or currentVariant
    // Don't rely on disable-select-size class as it may be set even when size is selected
    const isSizeSelected = this.isSizeSelected();
    if (!isSizeSelected) {
      // Don't check notify button if size is not selected yet
      return;
    }

    // Find matching variant in Pre-Order product and verify inventory
    const matchingPreOrderVariant = this.findMatchingPreOrderVariant();
    if (!matchingPreOrderVariant || !matchingPreOrderVariant.available) {
      // No matching pre-order variant available, check notify button
      this.toggleNotifyButton();
      return;
    }
    
    // Check country restrictions - read from window.theme to ensure latest values
    const countryCode = window.theme?.country_code || this.countryCode;
    const enablePreOrderNonUSA = window.theme?.enable_pre_order_non_usa !== undefined 
      ? window.theme.enable_pre_order_non_usa 
      : this.enablePreOrderNonUSA;
    const isUSA = countryCode === 'US';
    const canShowPreOrder = isUSA || enablePreOrderNonUSA;
    
    if (!canShowPreOrder) {
      // Can't show pre-order due to country restrictions, check notify button
      this.toggleNotifyButton();
      return;
    }
    
    // Show Pre-Order button if:
    // 1. enable_pre_order is enabled (regardless of original product availability), OR
    // 2. Original product is sold out AND waitlist-template is enabled
    const waitlistEnabled = productForm.classList.contains("waitlist-template");
    const shouldShowPreOrder = 
      this.enablePreOrder || 
      (!this.currentVariant.available && waitlistEnabled);

    if (shouldShowPreOrder) {
      preOrderButton.classList.remove("hidden");
      preOrderButton.dataset.preOrderVariantId = matchingPreOrderVariant.id;
      this.updatePreOrderButtonContent(preOrderButton, matchingPreOrderVariant);
      // Set flag to true when pre-order is available
      this.hasPreOrderAvailable = true;
      // Hide notify button when pre-order button is shown
      this.toggleNotifyButton();
    } else {
      // If pre-order button is hidden, check if notify button should be shown
      this.toggleNotifyButton();
    }
  }

  isSizeSelected() {
    // Check for radio buttons (variant-radios)
    const sizeOptionGroups = document.querySelectorAll('.product-form__input[data-option-name="Size"], .product-form__input[data-option-name="size"]');
    
    if (sizeOptionGroups.length > 0) {
      return Array.from(sizeOptionGroups).some(group => {
        const checkedSize = group.querySelector('input[type="radio"]:checked');
        return checkedSize && checkedSize.value;
      });
    }
    
    // Check selects (variant-selects)
    const mainProductInfo = document.getElementById("main-product-info");
    if (mainProductInfo) {
      try {
        const productInfo = JSON.parse(mainProductInfo.innerHTML);
        const optionsNames = productInfo.options_names || [];
        const sizeIndex = optionsNames.findIndex(name => {
          const lowerName = name.toLowerCase();
          return lowerName === 'size' || lowerName === 'talla';
        });
        
        if (sizeIndex >= 0) {
          const sizeSelect = document.querySelector(`#Option-${this.dataset.section}-${sizeIndex}, #SingleOptionSelector-${sizeIndex}`);
          if (sizeSelect && sizeSelect.value) {
            const firstOption = sizeSelect.options[0];
            return firstOption && sizeSelect.value !== firstOption.value;
          }
        }
      } catch (e) {
        // Fall through to currentVariant check
      }
    }
    
    // Fallback: verify size from currentVariant (most reliable)
    if (this.currentVariant && this.currentVariant.options) {
      const sizeValue = this.currentVariant.option2 || this.currentVariant.option1;
      return sizeValue && sizeValue.trim() !== '';
    }
    
    return false;
  }

  updatePreOrderButtonContent(button, variant) {
    const priceElement = button.querySelector(".preorder-button-price");
    const comparePriceElement = button.querySelector(".preorder-button-compare-price");
    const dateElement = button.querySelector(".preorder-button-date");
    
    // Update price
    if (priceElement && variant) {
      const price = variant.price / 100; // Convert from cents to dollars
      const compareAtPrice = variant.compare_at_price ? variant.compare_at_price / 100 : null;
      const currencySymbol = window.theme?.cart_currency_symbol || '$';
      const shopCurrency = window.theme?.shop_currency || '';
      
      // Show compare at price if exists (tachado)
      if (comparePriceElement && compareAtPrice && compareAtPrice > price) {
        comparePriceElement.innerHTML = `<s>${currencySymbol}${Shopify.formatMoneyAmmount(compareAtPrice)} ${shopCurrency}</s> `;
        comparePriceElement.style.display = 'inline';
      } else if (comparePriceElement) {
        comparePriceElement.textContent = '';
        comparePriceElement.style.display = 'none';
      }
      
      // Show current price
      priceElement.textContent = `${currencySymbol}${Shopify.formatMoneyAmmount(price)} ${shopCurrency}`;
    }
    
    // Update estimated ship date if available
    if (dateElement && window.theme?.pre_order_date) {
      const formattedDate = this.formatPreOrderDate(window.theme.pre_order_date);
      if (formattedDate) {
        dateElement.textContent = `Wait & Save: Estimated to Ship ${formattedDate}`;
      } else {
        dateElement.textContent = '';
      }
    } else if (dateElement) {
      dateElement.textContent = '';
    }
  }

  formatPreOrderDate(dateString) {
    if (!dateString) return null;
    
    try {
      // Parse date string (format: YYYY-MM-DD)
      const date = new Date(dateString + 'T00:00:00');
      if (isNaN(date.getTime())) return null;
      
      // Format to "Feb 15" format
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = months[date.getMonth()];
      const day = date.getDate();
      
      return `${month} ${day}`;
    } catch (error) {
      console.error('Error formatting pre-order date:', error);
      return null;
    }
  }

  findMatchingPreOrderVariant() {
    if (!this.preOrderProduct || !this.currentVariant) {
      return null;
    }

    const currentOptions = this.currentVariant.options || [];
    const mainProductInfo = document.getElementById("main-product-info");
    if (!mainProductInfo) {
      return null;
    }
    
    const productInfo = JSON.parse(mainProductInfo.innerHTML);
    const optionsNames = productInfo.options_names || [];
    
    // Find Color index to exclude it from matching
    const colorIndex = optionsNames.findIndex(name => {
      const lowerName = name.toLowerCase();
      return lowerName === 'color' || lowerName === 'couleur';
    });
    
    // Match variant by all options except color
    return this.preOrderProduct.variants.find(variant => {
      if (!variant.options || variant.options.length !== currentOptions.length) {
        return false;
      }
      
      // Match all options except color
      for (let i = 0; i < currentOptions.length; i++) {
        if (i !== colorIndex && variant.options[i] !== currentOptions[i]) {
          return false;
        }
      }
      
      return true;
    }) || null;
  }

  toggleShowBtn() {
    const addButton = document.querySelector(".product-form__submit");
    const notifyButton = document.querySelector(".klaviyo-bis-trigger");
    let radioGroups = document.querySelectorAll(".product-form__input:not(.jean-pack)");
    const productForm = document.querySelector("product-form.product-form");
    const Packs = document.querySelector(".pack-size__list");
    console.log(isNaN(Packs));


    if (document.querySelector("jean-pack-size")) {
      radioGroups = document.querySelectorAll(".product-form__input:not(.jean-pack)");
    }


    var showFlag = 0;

    if (isNaN(Packs) && !document.querySelector("jean-pack-size")) {
      const radioPackInputs = Packs.querySelectorAll(
        "input[type='radio']:checked"
      );
      showFlag++;
    }

    radioGroups.forEach((optionGroup) => {
      const radioInputs = optionGroup.querySelectorAll(
        "input[type='radio']:checked"
      );
      if (
        optionGroup.dataset.optionName !== "Color" && optionGroup.dataset.optionName !== "Couleur" &&
        typeof optionGroup.dataset.optionName !== "undefined" &&
        radioInputs.length > 0
      ) {
        showFlag++;
      }
    });
    
    if (showFlag == radioGroups.length - 1) {
      console.log("sf 1");
      // addButton.style.display = 'block';
      if (document.querySelector("multi-bundle")) {
        /**
         * multibundle next btn
         */
      } else {
        // Handle Notify button visibility
        this.toggleNotifyButton();
      }
    } else {
      console.log("sf 2");
      // addButton.style.display = 'none';
      if (document.querySelector('multi-bundle')) {
        /**
         * multibundles code
        */
        console.log('multibundles code  3f');
      } else {
        // Hide notify button when size is not selected
        notifyButton.classList.add("hide");
        notifyButton.classList.remove("enabled");
        addButton.classList.add("disable-select-size");
        addButton.style.display = 'block';
        addButton.disabled = false;
      }
      console.log("add disable b 2");
    }
    if (
      productForm &&
      productForm.classList.contains("giftcard-form") &&
      showFlag == radioGroups.length
    ) {
      addButton.classList.remove("disable-select-size");
      console.log("remove disable b 2");
    }
    if (
      productForm &&
      productForm.classList.contains("giftcard-form") &&
      showFlag == radioGroups.length
    ) {
      addButton.classList.remove("disable-select-size");
      console.log("remove disable b 2");
    }
  }

  availableSize() {
    if (document.querySelector("multi-bundle")) {
    } else {
      const addButton = document.querySelector(".product-form__submit");
      addButton.classList.remove("disable-select-size");
      console.log("remove disable b 3");
      addButton.previousElementSibling.style.display = "none";
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    // window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    const params = new URLSearchParams(window.location.search);
    params.set('variant', this.currentVariant.id);
    window.history.replaceState({}, '', `${location.pathname}?${params.toString()}`);

  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateFinalSaleProp(product) {
    let finalSale = false;
    if (
      product.tags &&
      product.tags.includes("mens-final-sale") ||
      product.tags &&
      product.tags.includes("womens-final-sale")
    )
      finalSale = true;
    document
      .querySelector(`#product-form-${this.dataset.section}`)
      .querySelector('input[name="properties[_final_sale]"]').value = `${finalSale ? "yes" : "no"
      }`;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        //if (source && destination) destination.innerHTML = source.innerHTML;

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove("visibility-hidden");

        // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      .querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) {
        const textElement = addButton.querySelector(".addtocart-button-text");
        if (textElement) {
          textElement.textContent = text;
        } else {
          addButton.textContent = text;
        }
      }
    } else {
      addButton.removeAttribute("disabled");
      // Update button content using the new format
      this.updateAddToCartButtonContent(addButton);
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    // addButton.textContent = window.variantStrings.soldOut;
    // document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    // this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.variantData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );

    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.sectionId = this.dataset.section;

    // initialize as if variant has changed
    // this.onVariantChange();
    this.updateOptions();
   
    if (predictProduct){
      console.log('predictProduct', predictProduct);
      this.currentProduct = predictProduct;
    }

    this.firstValidation().then(() => {
      //this.onVariantChange();
      this.onVariantChange();
      this.disableUnavailableSwatch();
      // recognize the queryparam variant
      const params = new URLSearchParams(window.location.search);
      const variantId = params.get("variant");
      // select the variant if it exists
      if (variantId) {
        let productInfo = document.getElementById("main-product-info");
        if (productInfo) productInfo = JSON.parse(productInfo.innerHTML);
        // get the variant options from the main-product-info productInfo options array
        console.log("productInfo", productInfo);
        let variant = productInfo.variants.find((variant) => {
          return variant.id == variantId;
        });

        if (document.querySelector(".product-form__input[data-option-name='Inseam']")) {
          let option = variant.options;
          let options_names = productInfo.options_names;
          let waist = option[options_names.indexOf("Waist")];
          let inseam = option[options_names.indexOf("Inseam")];
          let waistInput = this.querySelector(
            `input[type="radio"][value="${waist}"][name="Waist"]`
          );
          let inseamInput = this.querySelector(
            `input[type="radio"][value="${inseam}"][name="Inseam"]`
          );
          if (waistInput && waistInput.disabled == false) {
            waistInput.checked = true;
          }
          if (inseamInput && inseamInput.disabled == false) {
            inseamInput.checked = true;
          }
          waistInput.dispatchEvent(new Event("change", { bubbles: true }));
          inseamInput.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          let option = variant.options;
          let options_names = productInfo.options_names;
          let size = option[options_names.indexOf("Size")];
          let sizeInput = this.querySelector(
            `input[type="radio"][value="${size}"]`
          );
          if (sizeInput) {
            sizeInput.checked = true;
          }
          sizeInput.dispatchEvent(new Event("change", { bubbles: true }));


        }
      } else {
        if (document.querySelector(".product-form__input[data-option-name='Inseam']")) {
          setTimeout(() => {
            let disabledInput = this.querySelectorAll(
              `input[type="radio"][disabled]`
            );
            if (disabledInput) {
              disabledInput.forEach((input) => {
                input.disabled = false;
              });
            }
          }, 500);
        }
      }

    });
  }


  async firstValidation() {
    let productInfo = document.getElementById("main-product-info");
    if (productInfo) {
      productInfo = JSON.parse(productInfo.innerHTML);
      this.reInitVariants(productInfo);

      return;
    } else {
      return
    }
  }

  disableUnavailableSwatch() {

    const variants = this.getVariantData();

    const productForm = document.querySelector("product-form.product-form");
    if (productForm.classList.contains("waitlist-template")) {
      //return;
    }
    if (productForm.classList.contains("giftcard-form")) {
      return;
    }
    this.querySelectorAll(`input[type="radio"]`).forEach((radioItem) => {
      //radioItem.disabled = false;
    });
    if (this.options) {
      const formattedOptions = this.options.map((option, index) => {
        return {
          option: `option${index + 1}`,
          value: option,
        };
      });

      const varOptions = formattedOptions.filter((opt) => {
        const currentOptionFieldset = this.querySelector(
          `fieldset[data-option-index="${opt.option}"]`
        );
        if (currentOptionFieldset.dataset.optionName !== "Color" && currentOptionFieldset.dataset.optionName !== "Couleur") return opt;
      });

      let tags = '';
      tags = this.dataset.tags;
      console.log('tags', tags);
      //console.log('tags', tags);
      if (varOptions && varOptions.length > 1) {
        const selectedFieldSets = varOptions.filter(
          (varOption) => varOption.value != ""
        );
        if (selectedFieldSets.length) {
          selectedFieldSets.forEach((opt) => {

            const otherOptionIndex =
              ((parseInt(opt.option.replace("option", "")) - 2) ^ 1) + 2;
            const varoptFieldset = this.querySelector(
              `fieldset[data-option-index="option${otherOptionIndex}"]`
            );
            const properInputs = varoptFieldset.querySelectorAll(
              'input[type="radio"]'
            );
            const selectedVariants = variants.filter(
              (variant) => variant[opt.option] === opt.value
            );
            properInputs.forEach((inputElement) => {
              const properVariants = selectedVariants.filter(
                (variant) =>
                  variant[`option${otherOptionIndex}`] == inputElement.value
              );

              let title = '';
              if (properVariants.length) title = properVariants[0].sku?.replace(/[\-_]/g, '').toLowerCase();

              let disabledVariantTag = `dwl_${title}`;
              let tagIncludesHidedNotAvailableVariant = tags.includes('not_hide_not_existent_variants');
              let hideVariantTag = `hide_${title}`;
              let tagIncludesDisabledVariant = tags.includes(disabledVariantTag);
              let tagIncludesHideVariant = tags.includes(hideVariantTag);

              // hidden size
              inputElement.classList.remove("hidded-size");
              if (properVariants.length && tagIncludesHideVariant || !title && !tagIncludesHidedNotAvailableVariant) {
                inputElement.classList.add("hidded-size");
              } else if (inputElement.classList.contains("hidded-size")) {
                inputElement.classList.remove("hidded-size");
              }

              if (productForm.classList.contains("waitlist-template")) {


                if (properVariants.length && tagIncludesDisabledVariant && !properVariants[0].available) {
                  inputElement.disabled = true;
                } else if (!properVariants.length) {
                  inputElement.disabled = true;
                } else {
                  inputElement.disabled = false;
                }
              } else {
                if (properVariants.length) {
                  inputElement.disabled = !properVariants[0].available;
                } else {
                  inputElement.disabled = true;
                }
              }



            });
          });
        } else {
          // disable the ones with no inventory status

          const otherOptionIndex = 2;
          const varoptFieldset = this.querySelector(
            `fieldset[data-option-index="option${otherOptionIndex}"]`
          );
          const properInputs = varoptFieldset.querySelectorAll(
            'input[type="radio"]'
          );
          properInputs.forEach((inputElement) => {
            const properVariants = variants.filter(
              (variant) =>
                variant[`option${otherOptionIndex}`] == inputElement.value
            );

            let title = '';

            if (properVariants.length) title = properVariants[0].sku?.replace(/[\-_]/g, '').toLowerCase();

            let disabledVariantTag = `dwl_${title}`;
            console.log('disabledVariantTag', disabledVariantTag);
            let hideVariantTag = `hide_${title}`;
            let tagIncludesHidedNotAvailableVariant = tags.includes('not_hide_not_existent_variants');
            let tagIncludesDisabledVariant = tags.includes(disabledVariantTag);
            let tagIncludesHideVariant = tags.includes(hideVariantTag);

            // hidden size
            //inputElement.classList.remove("hidded-size");
            if (properVariants.length && tagIncludesHideVariant || !title && !tagIncludesHidedNotAvailableVariant) {
              //inputElement.classList.add("hidded-size");
            } else if (inputElement.classList.contains("hidded-size")) {
              //inputElement.classList.remove("hidded-size");
            }

            if (productForm.classList.contains("waitlist-template")) {

              if (properVariants.length && tagIncludesDisabledVariant && !properVariants[0].available) {
                inputElement.disabled = true;

              } else {
                inputElement.disabled = false;
              }
            } else {
              if (properVariants.length) {
                inputElement.disabled = false;
              } else {
                inputElement.disabled = true;
              }
            }

          });
        }
      } else {
        const selectedFieldSets = varOptions.filter(
          (varOption) => varOption.value != ""
        );
        if (selectedFieldSets.length) {
          selectedFieldSets.forEach((opt) => {
            const otherOptionIndex = 2;
            const varoptFieldset = this.querySelector(
              `fieldset[data-option-index="option${otherOptionIndex}"]`
            );
            const properInputs = varoptFieldset.querySelectorAll(
              'input[type="radio"]'
            );
            const selectedVariants = variants.filter(
              (variant) => variant[opt.option] === opt.value
            );
            properInputs.forEach((inputElement) => {
              const properVariants = variants.filter(
                (variant) =>
                  variant[`option${otherOptionIndex}`] == inputElement.value
              );

              let title = '';

              if (properVariants.length) title = properVariants[0].sku?.replace(/[\-_]/g, '').toLowerCase();

              let disabledVariantTag = `dwl_${title}`;
              let hideVariantTag = `hide_${title}`;
              let tagIncludesHidedNotAvailableVariant = tags.includes('not_hide_not_existent_variants');
              let tagIncludesDisabledVariant = tags.includes(disabledVariantTag);
              let tagIncludesHideVariant = tags.includes(hideVariantTag);

              // hidden size
              inputElement.classList.remove("hidded-size");

              if (properVariants.length && tagIncludesHideVariant || !title && !tagIncludesHidedNotAvailableVariant) {
                inputElement.classList.add("hidded-size");
              } else if (inputElement.classList.contains("hidded-size")) {
                inputElement.classList.remove("hidded-size");
              }

              if (productForm.classList.contains("waitlist-template")) {

                if (properVariants.length && tagIncludesDisabledVariant && !properVariants[0].available) {
                  inputElement.disabled = true;

                } else {
                  inputElement.disabled = false;
                }
              } else {
                if (properVariants.length) {
                  inputElement.disabled = !properVariants[0].available;
                } else {
                  inputElement.disabled = true;
                }
              }



            });
          });
        } else {
          // disable the ones with no inventory status

          const otherOptionIndex = 2;
          const varoptFieldset = this.querySelector(
            `fieldset[data-option-index="option${otherOptionIndex}"]`
          );
          const properInputs = varoptFieldset.querySelectorAll(
            'input[type="radio"]'
          );
          properInputs.forEach((inputElement) => {
            const properVariants = variants.filter(
              (variant) =>
                variant[`option${otherOptionIndex}`] == inputElement.value
            );

            let title = '';
            if (properVariants.length) title = properVariants[0].sku?.replace(/[\-_]/g, '').toLowerCase();

            let disabledVariantTag = `dwl_${title}`;
            let hideVariantTag = `hide_${title}`;
            let tagIncludesHidedNotAvailableVariant = tags.includes('not_hide_not_existent_variants');
            let tagIncludesDisabledVariant = tags.includes(disabledVariantTag);
            let tagIncludesHideVariant = tags.includes(hideVariantTag);

            // hidden size
            inputElement.classList.remove("hidded-size");
            if (properVariants.length && tagIncludesHideVariant || !title && !tagIncludesHidedNotAvailableVariant) {
              inputElement.classList.add("hidded-size");
            } else if (inputElement.classList.contains("hidded-size")) {
              inputElement.classList.remove("hidded-size");
            }

            if (productForm.classList.contains("waitlist-template")) {


              if (properVariants.length && tagIncludesDisabledVariant && !properVariants[0].available) {
                inputElement.disabled = true;

              }
              else {
                inputElement.disabled = false;
              }
            } else {
              if (properVariants.length) {
                inputElement.disabled = !properVariants[0].available;
              } else {
                inputElement.disabled = true;
              }
            }

          });
        }
      }
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.disableUnavailableSwatch();
    this.formatOptionsData();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    if (this.currentVariant && this.currentVariant.available) {
      this.availableSize();
      this.updateMedia();
      this.updateVariantInput();

      if (document.querySelector("multi-bundle")) {
        /**
         * multibundle next btn enable
         */
        this.enablemultibundlesNext(true, this.currentVariant);
      } else {
        this.renderProductInfo();
        this.enableSubmitBtn();
        // Update Add to Cart button content after enabling
        const addButton = document.querySelector(".product-form__submit");
        if (addButton) {
          this.updateAddToCartButtonContent(addButton);
        }
        // Handle Notify button visibility
        this.toggleNotifyButton();
        // Handle Pre-Order button visibility (check inventory for available variants)
        if (this.preOrderHandle && !this.preOrderProduct) {
          this.loadPreOrderProduct().then(() => {
            this.togglePreOrderButton();
            // Update Add to Cart button after pre-order check
            const addButton = document.querySelector(".product-form__submit");
            if (addButton) {
              this.updateAddToCartButtonContent(addButton);
            }
          });
        } else {
          this.togglePreOrderButton();
          // Update Add to Cart button after pre-order check
          const addButton = document.querySelector(".product-form__submit");
          if (addButton) {
            this.updateAddToCartButtonContent(addButton);
          }
        }
      }
    } else {
      const productForm = document.querySelector("product-form.product-form");
      if (!productForm.classList.contains("waitlist-template")) {
        // Still check for Pre-Order button even if variant is not available
        if (this.preOrderHandle && !this.preOrderProduct) {
          this.loadPreOrderProduct().then(() => {
            this.togglePreOrderButton();
            // Update Add to Cart button after pre-order check
            const addButton = document.querySelector(".product-form__submit");
            if (addButton) {
              this.updateAddToCartButtonContent(addButton);
            }
          });
        } else {
          this.togglePreOrderButton();
          // Update Add to Cart button after pre-order check
          const addButton = document.querySelector(".product-form__submit");
          if (addButton) {
            this.updateAddToCartButtonContent(addButton);
          }
        }
        return;
      }
      //       if(!productForm.classList.contains('preorder-template')) {
      //    console.log("here")
      //    return;
      //       }
      this.disableSubmitBtn();
      // Check for Pre-Order button for sold out products
      if (this.preOrderHandle && !this.preOrderProduct) {
        this.loadPreOrderProduct().then(() => {
          this.togglePreOrderButton();
          // Update Add to Cart button after pre-order check
          const addButton = document.querySelector(".product-form__submit");
          if (addButton) {
            this.updateAddToCartButtonContent(addButton);
          }
        });
      } else {
        this.togglePreOrderButton();
        // Update Add to Cart button after pre-order check
        const addButton = document.querySelector(".product-form__submit");
        if (addButton) {
          this.updateAddToCartButtonContent(addButton);
        }
      }
    }

    if (document.querySelector("multi-bundle")) { } else {
      this.updateURL();
      this.toggleShowBtn();
    }

    //console.log("toggleShowBtn 2");
  }

  // renderSizeGuideBtn(){
  //   const hasSizeGuide = document.querySelector('#size-chart-modal-bg');
  //   if(!hasSizeGuide) return;

  //   const button = document.createElement('button');
  //   button.textContent = 'Size Guide';
  //   button.classList.add('pdp_size-guide');
  //   button.addEventListener('click', () => {
  //     document.querySelector('#size-chart-modal-bg').classList.toggle('open');
  //   });
  //   this.appendChild(button);
  // } 

  enablemultibundlesNext(enable = true, variant) {
    if (this.multiBundle) {
      this.multiBundle.nextButtonsSelectors.forEach(btn => {

        if (enable) {
          btn.dataset.disabled = "false";
          //btn.disabled = false;
          btn.dataset.selectedVariant = JSON.stringify(variant);
        } else {
          btn.dataset.disabled = "true";
          //btn.disabled = true;
        }
      })
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => {
          return radio.checked;
        }
      );
      return checkedRadio ? checkedRadio.value : "";
    });
  }

  formatOptionsData() {
    if (this.options) {
      const formattedOptions = this.options.map((option, index) => {
        return {
          option: `option${index + 1}`,
          value: option,
        };
      });

      this.resetVariantBtns();
      this.filterOutUnavailableVariants(formattedOptions);
    }
  }

  resetVariantBtns() {
    this.querySelectorAll("fieldset input[type='radio']").forEach((radio) => {
      radio.classList.add("disabled");
    });
  }

  filterOutUnavailableVariants(options) {
    const variants = this.getVariantData();
    const varOptions = options.filter((opt) => {
      const currentOptionFieldset = this.querySelector(
        `fieldset[data-option-index="${opt.option}"]`
      );
      if (currentOptionFieldset.dataset.optionName !== "Color" && currentOptionFieldset.dataset.optionName !== "Couleur") return opt;
    });

    if (varOptions && varOptions.length > 1) {
      this.filterOnMultipleOptions(varOptions, variants);
    } else {
      this.filterOnSingleOption(varOptions, variants);
    }
  }

  filterOnSingleOption(options, variants) {
    options.forEach((opt) => {
      const availVarsWithCurrentOption = variants
        .filter((variant) => variant.available === true)
        .map((filteredvariant) => {
          return {
            ...filteredvariant,
            options_object: filteredvariant.options.map((varoption, i) => {
              return { option: `option${i + 1}`, value: varoption };
            }),
          };
        });
      availVarsWithCurrentOption.forEach((variant) => {
        variant.options_object.forEach((varopt) => {
          if (varopt.option !== opt.option) return;
          else {
            const varoptFieldset = this.querySelector(
              `fieldset[data-option-index="${varopt.option}"]`
            );
            varoptFieldset.dataset.optionName === "Color" || varoptFieldset.dataset.optionName === "Couleur"
              ? ""
              : varoptFieldset
                .querySelector(`input[value="${varopt.value}"]`)
                .classList.remove("disabled");
          }
        });
      });
    });
  }

  filterOnMultipleOptions(options, variants) {
    options.forEach((opt) => {
      const availVarsWithCurrentOption = variants
        .filter(
          (variant) =>
            (variant[opt.option] === opt.value || opt.value === "") &&
            variant.available === true
        )
        .map((filteredvariant) => {
          return {
            ...filteredvariant,
            options_object: filteredvariant.options.map((varoption, i) => {
              return { option: `option${i + 1}`, value: varoption };
            }),
          };
        });
      availVarsWithCurrentOption.forEach((variant) => {
        variant.options_object.forEach((varopt) => {
          if (varopt.option === opt.option) return;
          else {
            const varoptFieldset = this.querySelector(
              `fieldset[data-option-index="${varopt.option}"]`
            );
            varoptFieldset.dataset.optionName === "Color" || varoptFieldset.dataset.optionName === "Couleur"
              ? ""
              : varoptFieldset
                .querySelector(`input[value="${varopt.value}"]`)
                .classList.remove("disabled");
          }
        });
      });
    });
  }

  reInitVariants(product) {
    var options = product.options;
   
    const variants = product.variants;
    if (options.length > 0 && options[0].name === "Color" && options[0].values.length > 1) {
      options[0].values = [options[0].values[0]];
    }
    fetch(`${Shopify.routes.root}products/${product.handle}?view=metafields`)
      .then((response) => response.json())
      .then((metadata) => {
        this.currentProduct = product;
        const radioGroups = document.querySelectorAll(".product-form__input:not(.jean-pack)");
        var currentRadioStatus = [];
        radioGroups.forEach((optionGroup) => {
          const radioInputs = optionGroup.querySelectorAll(
            "input[type='radio']:checked"
          );
          if (optionGroup.dataset.optionName != "Color" && optionGroup.dataset.optionName != "Couleur") {
            if (radioInputs.length > 0) {
              currentRadioStatus.push({
                option_name: optionGroup.dataset.optionName,
                option_value: radioInputs[0].value,
              });
            } else {
              currentRadioStatus.push({
                option_name: optionGroup.dataset.optionName,
                option_value: "",
              });
            }
          }
        });

        this.resetForm();

        /**
         * Multibundle toEdit
         */
        if (this.toEdit) currentRadioStatus = this.toEdit;

        this.resetFieldSets(options, variants, metadata, currentRadioStatus);
        // manually trigger onchange event
        this.onVariantChange();
        
        // Update Add to Cart button after variant change (with delay to ensure variant is set)
        setTimeout(() => {
          // Also update Pre-Order button after variant change
          this.togglePreOrderButton();
          // Update Add to Cart button after pre-order check
          const addButton = document.querySelector(".product-form__submit");
          if (addButton) {
            this.updateAddToCartButtonContent(addButton);
          }
        }, 150);

        if (document.querySelector("multi-bundle")) {
          console.log('multi bundle line 1380');
        } else {
          this.updateFinalSaleProp(product);
        }

        // render the sizeguide button
        // this.renderSizeGuideBtn();

        this.updateWairPlacement(product);

        if (this.currentVariant && this.currentVariant.available) {
          //alert("available");
          console.log({
            product, variant: this.currentVariant
          });

          //console.log('next selectors: ',this.multiBundle.nextButtonsSelectors);
          this.enablemultibundlesNext(true, this.currentVariant);

          if (document.querySelector('multi-bundle')) {
            /**
             * variant radios code
             */
            console.log('variant radios code 2f');
          } else {
            this.enableSubmitBtn();
          }
        } else {
          if (document.querySelector('multi-bundle')) {
            /**
             * variant radios code
             */
            console.log('variant radios code 55f');
          } else {
            this.disableSubmitBtn();
          }
          //alert("not available");
          this.enablemultibundlesNext(false);
        }


        this.toggleShowBtn();
        console.log("toggleShowBtn 3");
      });

    // this.resetFieldSets(options, variants);
    
  }

  resetForm() {
    this.innerHTML = "";
  }

  formatWairProductKey(productHandle) {
    if (
      productHandle &&
      (productHandle.startsWith("bdl6-mubb") ||
        productHandle.startsWith("bdl3-mubb"))
    ) {
      return "mubb-sssm-blac";
    } else if (
      productHandle &&
      (productHandle.startsWith("bdl6-mutr") ||
        productHandle.startsWith("bdl3-mutr"))
    ) {
      return "mutr-sssm-blac";
    } else {
      return productHandle;
    }
  }

  updateWairPlacement(product) {
    const wairPlacementEls = document.querySelectorAll(".predict-placement");

    wairPlacementEls.forEach((el) => {
      el.dataset.predictProductKey = this.formatWairProductKey(product.handle);
      el.dataset.predictProductName = product.title;
      el.dataset.predictProductImg = product.featured_image;
    });
  }

  resetFieldSets(options, variants, metadata = "", currentRadioStatus = []) {

    console.log('currentRadioStatus    : ', currentRadioStatus);
    
    const fieldSets = options.map((option, optionIndex) => {
      const option_title = option.name.toLowerCase();
      const option_name = window.theme[`${option.name}`] ? window.theme[`${option.name}`] : option.name;
      const option_selected =
        option.name === "Color" || option.name === "Couleur"
          ? {}
          : currentRadioStatus.find(
            ({ option_name }) => option_name === option.name
          );
      return `
        <fieldset count="${option.values.length}" class="js product-form__input ${option.name.toLowerCase()}_convert" data-option-name="${option.name
        }" data-option-index="option${optionIndex + 1}">
          <legend class="form__label">${optionIndex < 2 ? option_name : window.theme.inseam_text
        }: <br><span class="option-meta-data">${metadata[option_title] ? metadata[option_title] : ""
        }</span></legend>
          ${option.values
          .map((value, index) => {
            console.log(option_selected);
            return `
              <input type="radio" id="${this.sectionId}-${option.name}-${index}"
                     name="${option.name}"
                     value="${value.trim()}"
                     form="product-form-${this.sectionId}"
                     ${option.name === "Color" || option.name === "Couleur"
                ? "checked"
                : option_selected &&
                  option_selected.option_value === value
                  ? "checked"
                  : ""
              }
              >
              <label for="${this.sectionId}-${option.name}-${index}">
                ${value}
              </label>
            `;
          })
          .join("")}
        </fieldset>
      `;
    });
    const variantJson = `
      <script type="application/json" id="variant-status">
        ${JSON.stringify(variants)}
      </script>
    `;
    this.innerHTML = fieldSets.join("") + variantJson;
  }
}

customElements.define("variant-radios", VariantRadios);

// Global function to update Pre-Order when product changes (can be called from fit-color-picker)
window.updatePreOrderOnProductChange = async function(productHandle, productTags) {
  const variantRadios = document.querySelector('variant-radios');
  if (variantRadios && variantRadios.updatePreOrderForNewProduct) {
    await variantRadios.updatePreOrderForNewProduct(productHandle, productTags);
    // The button will be updated in updatePreOrderForNewProduct and also in reInitVariants
  }
};

document.addEventListener("rebuy.add", async function () {
  try {


    fetch(`${this.domain}cart?sections=cart-json`)
      .then((response) => response.text())
      .then((html) => {
        let jsonData = JSON.parse(html);
        const htmlDiv = jsonData['cart-json'];
        // parse the HTML , need only the div textContent
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlDiv, 'text/html');
        const data = JSON.parse(doc.querySelector('#shopify-section-cart-json').textContent);
        const sideCart = document.querySelector("side-cart");
        sideCart.renderCartOrEmptyOut(data);
        sideCart.openCart();
      });
  } catch (err) {
    console.error(err);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    if (document.querySelector(".klaviyo-bis-trigger")) {
      document.querySelector(".klaviyo-bis-trigger").classList.remove("loading");
      document.querySelector(".klaviyo-bis-trigger").classList.remove("disabled");
    }
    
  }, 500);

});


/* Extra Intelligems mercer test code for plp */




var igLoaded = false;
window.addEventListener("message", (event) => {
  if (event.data === "ig-ready") {
    igLoaded = true;
    setTimeout(() => {
      if (document.querySelectorAll('product-card')) {
          document.querySelectorAll('product-card').forEach((card) => {
              if (!card.querySelector('.card-information__text')) return;
              let title = card.querySelector('.card-information__text').innerText;
             
              // if contanis Mercer and pack
              if (title.includes('MERCER') && title.includes('PACK')) {
                  
                  
                  let totalPrice = card.querySelector('.price-item.product-card.price-item--sale ').innerText; // example Straight Mercer Jeans 3-Pack
      
                  let packSize = title.split('Pack')[0].split(' ')[title.split('Pack')[0].split(' ').length - 1]; // this return something like 3-PACK , 
                  packSize = packSize.split('-')[0]; // this return 3
                  
                  // format usd to onlyu ammount $
                  let price = totalPrice.split('$')[1];
                  // price as number
                  price = parseFloat(price);
      
                  let badge = card.querySelector('.product_badge');
                  if (parseFloat(price) && packSize && badge && Shopify.currency.active == "USD") {
                      
                      let pricePerItem = price / packSize;
                      let pricePerItemText = `$${pricePerItem.toFixed(2)} EACH`;
                      badge.innerText = pricePerItemText;
                      
                  } else {
                      //debugger;
                  }
                  
      
              }
          });
      }
    }
    , 500);
   
    
  }
}); 




/**
 * FTC CODE
 * FTC: First time customer
 * ismbc : is mott and bow customer
 * epcall: endpoint call 
 */

function evaluateFirstTimeCustomerByUi() {
  let foundReceipt = false;

  try {
      let data = JSON.parse(localStorage.getItem("__ui"));

      if (!Array.isArray(data)) {
          return false;
      }

      foundReceipt = data.some(subArray => {
          if (!Array.isArray(subArray)) {
              return false;
          }
          return subArray.some(item => {
              if (item.receipt && item.receipt.status === "processed") {
                  return true;
              }
              return false;
          });
      });
  } catch (error) {
      console.error("Error evaluating first-time customer:", error);
  }

  return foundReceipt;
}
function readDasVariable() {
  // Read the 'mprtcl-v4_50F4D000' local storage
  const mprtc = localStorage.getItem('mprtcl-v4_50F4D000');
  console.log(mprtc);

  if (!mprtc) return false;

  try {
    // Replace '|' with ',' to make the string valid JSON
    const validJsonString = mprtc.replace(/\|/g, ',').replace(/'/g, '"');
    const parsedData = JSON.parse(validJsonString);
    const das = parsedData.gs && parsedData.gs.das;
    if (das) return das;
  } catch (error) {
    console.error("Error reading das variable:", error);
    console.error("Invalid JSON:", mprtc);
  }

  return false;
}

function evaluateFirstTimeCustomerByEndpoint() {
  return new Promise((resolve, reject) => {
    let payload = {
      "api_key": "Ok&zOB@0B3%$L9JI"
    };

    const userIp = localStorage.getItem("userLocationData") ? JSON.parse(localStorage.getItem("userLocationData")).ip : null;
    const das = readDasVariable();

    const email = takeEmailFromLocalStorage();
      
    if (!userIp && !email) {
      //return resolve(false); 
    }
    
    userIp? payload["client_ip"] = userIp : null;
    email? payload["email"] = email : null;
    das? payload["das"] = das : null;  
    

    fetch("https://us-central1-mb-data-lake.cloudfunctions.net/customer_data_ftc_public", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(response => response.json())
      .then(data => {
        console.log('Success:', data);


        if (data && Object.values(data).some(value => value === true)) {
          resolve(data);
        } else {
          resolve(false);
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        reject(error);
      });
  });
}

function takeEmailFromLocalStorage() {
  let email = null;

  const emaim_from___em = localStorage.getItem('__em');
  const __ui = JSON.parse(localStorage.getItem("__ui"));
  const email_from_wo = localStorage.getItem('wo_email');
  const emaim_from_klaviyo = localStorage.getItem('klaviyo_email');
  

  if (emaim_from___em) {
    return emaim_from___em;
  }

  __ui? email = __ui.reduce((email, subArray) => {
    if (email) return email;
    if (!Array.isArray(subArray)) return null;

    const itemWithEmail = subArray.find(item => item.receipt);
    return itemWithEmail ? itemWithEmail.receipt.purchaseOrder.email : null;
  }, null) : null;
  

  if (!email && email_from_wo) email = email_from_wo;
  if (!email && emaim_from_klaviyo) email = emaim_from_klaviyo; 

  email? localStorage.setItem("__em", email) : null;

  return email || null;
}

var omReadyTestFTC = 0;
function optimonkFTCampain(x) {


  (function () {
    var observerOpmk = new MutationObserver(function (mutations, observerInstance) {
      if (window.OptiMonk && window.OptiMonk.Visitor) {
          console.log("OptiMonk detected!");
          observerInstance.disconnect();
          var OptiMonkOnReady = function () {
            var adapter = OptiMonk.Visitor.createAdapter();
            adapter.attr('ismbc', x);
          };
          OptiMonkOnReady();
          
        }
      });
      observerOpmk.observe(document.body, { childList: true, subtree: true });
    })();
    
  
}

/**
 * evaluate if the local storage variable ismbc exist
 * if not evaluate if the __ui local storage variable exist and return true if the user is a first time customer
 * if not evaluate the endpoint and return true if the user is a mott and bow customer
 */



async function evalFTC(forceEpcall = false) {
  let ismbc = localStorage.getItem("ismbc");
  let epcall = JSON.parse(localStorage.getItem("epcall"));

  /**
   * como ismbc se esta definiendo = 1 en el evento de checkout_completed
   * si un usuario ya compro, no pasa por aca 
   * va directo al else y se termina la funcion
   */
  if (!ismbc || ismbc != 1 || forceEpcall) {
      // if epcall does not exist OR epcall value is false and epcall date is more than 86400000 (1 day) or forceEpcall is true
      if ( !epcall || (!epcall?.value && (new Date() - new Date(epcall?.date)) > 86400000) || forceEpcall) { 
            evaluateFirstTimeCustomerByEndpoint()
            .then(existEP => {
              const epCallValue = existEP && Object.values(existEP).some(value => value === true) === true ? true : false;
              const ismbcValue = epCallValue ? 1 : 0;
              
                localStorage.setItem("ismbc", ismbcValue); 
                localStorage.setItem("epcall", JSON.stringify({
                  "date": new Date(),
                  "value": epCallValue
                }));
                return ismbcValue;
            })
            .catch(error => {
              console.error('Error evaluating first-time customer by endpoint:', error);
                return 0;
            });
      } else if (epcall.value) { // if epcall value is true
        return 1;
      } else {
        return 0;
      }
  } else  {
    return ismbc;
  }
  
}
evalFTC().then((x) => {
  localStorage.setItem("ismbc", x);
  optimonkFTCampain(x);
});

function evalFTCElemets(force_notfct = false) {
  let ismbc = localStorage.getItem("ismbc");
  const subHeroText = document.querySelector('.set-text-plp'); 

  if (ismbc && ismbc == 1 || force_notfct) {
    const notFtcElements = document.querySelectorAll('.not-ftc');
    notFtcElements.forEach(element => {
      element.classList.remove('hidden');
    });

    if (subHeroText) {
      subHeroText.classList.remove('hidden');
    }

  } else {
    const ftcElements = document.querySelectorAll('.ftc');
    ftcElements.forEach(element => {
      element.classList.remove('hidden');
    });

    if (subHeroText) {
      subHeroText.innerText = 'Shop our premium essentials as sets. Free shipping options available!';
      subHeroText.classList.remove('hidden');
    }
  }
}

/**
 * END OF FTC CODE
 */